export default "<div *ngIf=\"loading\" class=\"app-loading\">\n  <mat-spinner></mat-spinner>\n</div>\n"